
<span
  :class="textClass"
  class="export-next-run"
  :aria-label="`Next run: ${displayText}`"
>
  <v-icon
    v-if="showIcon"
    :color="iconColor"
    x-small
    class="mr-1"
  >
    {{ icon }}
  </v-icon>
  {{ displayText }}
</span>
